import {CourseArticleDto, QuestionDto, UserDto} from '../../scaffold';

export default function CourseArticleKeywordFilter(article: CourseArticleDto, keyword: string) {
  return (article.topic || '').includes(keyword);
}
